export const omit = <T extends Record<string, unknown>>(
  obj: T,
  keys: (keyof T)[]
): Omit<T, keyof typeof keys> => {
  const result = { ...obj }
  keys.forEach((key) => {
    delete result[key]
  })
  return result
}
